import { useForm } from 'react-hook-form';
import { Modal, Button, Form } from 'react-bootstrap';
import { WrapperModal } from '../../../../shared/ModalLayout/styles';

interface Props {
  description?: string;
  show: boolean;
  onClose: () => void;
  onConfirm: (comment: string) => void;
  onReset?: () => void;
  title: string;
  isLoading?: boolean;
  labelCopy?: string;
  defaultComment?: string;
  authorizerOptions?: string[];
  authorizerLabel?: string;
}

export const RetryConfirmModal = ({
  description,
  show,
  onClose,
  onConfirm,
  onReset,
  title,
  isLoading,
  labelCopy,
  defaultComment,
  authorizerOptions,
  authorizerLabel,
}: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<{ comment: string; authorizer?: string }>({
    defaultValues: { comment: defaultComment ?? '', authorizer: '' },
  });

  const handleFormSubmit = ({
    comment,
    authorizer,
  }: {
    comment: string;
    authorizer?: string;
  }) => {
    const fullComment = authorizer
      ? `Autorizado por: ${authorizer}. ${comment.trim()}`
      : comment.trim();
    onConfirm(fullComment);
    reset();
    onClose();
  };

  const handleClose = () => {
    reset();
    onReset?.();
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <WrapperModal>
        <Modal.Header className="d-flex p-4 border-bottom-0">
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit(handleFormSubmit)}>
          <Modal.Body className="px-1 p-0 pb-3 px-4">
            <Form.Group>
              <p className="fw-bold mb-0 subtitle">{description}</p>
              {authorizerOptions && authorizerOptions.length > 0 && (
                <>
                  <Form.Label className="subtitle py-2 fw-bold">
                    {authorizerLabel}
                  </Form.Label>
                  <Form.Select
                    {...register('authorizer', {
                      required: 'Debes seleccionar un autorizador',
                    })}
                    isInvalid={!!errors.authorizer}
                    className="mb-2"
                  >
                    <option value="">Selecciona...</option>
                    {authorizerOptions.map(opt => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback className="fw-bold fs-5" type="invalid">
                    {errors.authorizer?.message}
                  </Form.Control.Feedback>
                </>
              )}
              <Form.Label className="subtitle py-2 fw-bold">
                {labelCopy}
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Deja un comentario..."
                {...register('comment', {
                  required: 'Este campo es obligatorio',
                  validate: value =>
                    value.trim() !== '' || 'Este campo es obligatorio',
                })}
                isInvalid={!!errors.comment}
              />
              <Form.Control.Feedback className="fw-bold fs-5" type="invalid">
                {errors.comment?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="d-flex flex-nowrap px-4 pb-4 border-top-0">
            <Button className="w-100 btn-habi-white" onClick={handleClose}>
              Cancelar
            </Button>
            <Button
              type="submit"
              className="w-100 btn-habi"
              disabled={isLoading}
            >
              {isLoading ? 'Enviando...' : 'Enviar'}
            </Button>
          </Modal.Footer>
        </Form>
      </WrapperModal>
    </Modal>
  );
};
